import React from "react";

// Import existing tool result components
import { RandomNumberToolResult } from "./RandomNumberToolResult";
import { AddNumbersToolResult } from "./AddNumbersToolResult";
import { PropertyInsightsToolResult } from "./PropertyInsightsToolResult";
import { GenericToolResult } from "./GenericToolResult";

// Import custom loading and executing components
import { PropertyInsightsLoading } from "./PropertyInsightsLoading";
import { PropertyInsightsExecuting } from "./PropertyInsightsExecuting";

// Specific tool argument types
export interface PropertyInsightsToolArgs {
  query: string;
}

// Types for tool UI components
export interface ToolUIComponents {
  LoadingComponent?: React.ComponentType<ToolLoadingProps>;
  ExecutingComponent?: React.ComponentType<ToolExecutingProps>;
  ResultComponent: React.ComponentType<ToolResultProps>;
}

export interface ToolLoadingProps {
  toolName: string;
  args?: Record<string, any>;
}

export interface ToolExecutingProps {
  toolName: string;
  args?: Record<string, any>;
}

export interface ToolResultProps {
  result: any;
  args?: Record<string, any>;
}

// Registry type
export type ToolLoadingRegistry = Record<string, ToolUIComponents>;

// Tool loading registry - maps tool names to their UI components
export const toolLoadingRegistry: ToolLoadingRegistry = {
  generate_random_number: {
    ResultComponent: RandomNumberToolResult,
  },
  
  add_numbers: {
    ResultComponent: ({ result, args }) => (
      <AddNumbersToolResult
        result={result}
        args={args as { num1: number; num2: number }}
      />
    ),
  },
  
  queryPropertyInsights: {
    LoadingComponent: PropertyInsightsLoading,
    ExecutingComponent: PropertyInsightsExecuting,
    ResultComponent: ({ result, args }) => (
      <PropertyInsightsToolResult
        result={result}
        args={args as PropertyInsightsToolArgs}
      />
    ),
  },
};

// Get tool UI components with fallback to generic
export const getToolUIComponents = (toolName: string): ToolUIComponents => {
  const toolComponents = toolLoadingRegistry[toolName];
  
  if (toolComponents) {
    return toolComponents;
  }
  
  // Fallback to generic components
  return {
    ResultComponent: ({ result }) => (
      <GenericToolResult toolName={toolName} result={result} />
    ),
  };
};